import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import nvStorage from '../helpers/storage';
import styles from '../styles/form.scss';
const WebRTCDisabled = () => {
    const logoSrc = useSelector((state) => state.branding.partnerLogoSrc || '');
    useEffect(() => {
        // Remove stored token
        nvStorage.remove('token');
        nvStorage.remove('token-remember');
        nvStorage.remove('token-expires');
    }, []);
    return (React.createElement("div", { className: styles.background },
        React.createElement("div", { className: styles.container },
            React.createElement("img", { alt: 'Logo', className: styles.logo, src: logoSrc }),
            React.createElement("div", { className: styles.form },
                React.createElement("div", { className: styles.form_content },
                    React.createElement("h2", { className: styles.title_smaller }, "WebRTC is disabled for this extension"),
                    React.createElement("div", { className: styles.form_body }, "Please get in touch to have it enabled."))))));
};
export default WebRTCDisabled;
